declare global {
  interface Window {
    skipAlloyAnalyticsLoad?: boolean;
  }
}

window.skipAlloyAnalyticsLoad = false;

import('./bootstrap');

export {};
